<template>
  <div class="select-box-wrapper">
    <div class="select-box" @click.stop="toggleDropDownList" role="select box">
      <button class="arrow-down"></button>
      <slot></slot>
    </div>
    <transition name="fade">
      <div
        class="dropdown-list-wrap"
        v-show="showdropDownList"
        v-clickOutside="closeDropDownList"
        role="select box dropdown list"
      >
        <!-- v-if="isShow" -->
        <ul class="dropdown-list">
          <!-- 下拉列表 -->
          <li
            class="dropdown-list-item"
            @click="listItemSelect(item, index)"
            v-for="(item, index) in listData"
            :key="index"
          >
            <!-- 不知道每个接口的字段是怎样的，做成slot格式，参考src/views/ProductionDetails/RetailDetails/Filter/index.vue           -->
            <slot name="itemDesc" :item="item"></slot>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
  import { clickOutside } from '@/utils/directive.js';

  export default {
    name: 'SelectBox',
    props: {
      listData: {
        type: Array,
        default: [],
      },
      // 多个下拉框的时候一个为true的话，另外一个应该为false（需求：两个列表只展示一个，不会同时展示多个）
      // isShow: {
      //   type: Boolean,
      //   default: true
      // },
      // 点击后显示下拉框列表
      // showdropDownList: {
      //   type: Boolean,
      //   default: false
      // },
    },

    directives: { clickOutside },

    data() {
      return {
        showdropDownList: false,
      };
    },

    methods: {
      toggleDropDownList() {
        this.$emit('toggleDropDownList');
        this.showdropDownList = !this.showdropDownList;
      },
      closeDropDownList(e) {
        console.log('asd', e.target.parentNode.className.includes('select-box-wrapper'));
        if (e.target.parentNode.className.includes('select-box-wrapper')) return;
        this.showdropDownList = false;
      },
      // 点击下拉框的某个选项
      listItemSelect(item, index) {
        this.$emit('handleListItemSelect', [item, index]);
        // this.showdropDownList = !this.showdropDownList;
        this.showdropDownList = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'index.scss';
</style>
